// Généré depuis citiesData.js — uniquement les slugs pour le routing.
// Évite d'embarquer ~256KB de contenu villes dans le bundle principal.
export const additionalSeoCitySlugs = [
  "/demenagement-sartrouville",
  "/demenagement-franconville",
  "/demenagement-rueil-malmaison",
  "/demenagement-houilles",
  "/demenagement-chatou",
  "/demenagement-montesson",
  "/demenagement-le-mesnil-le-roi",
  "/demenagement-le-vesinet",
  "/demenagement-bougival",
  "/demenagement-saint-cloud",
  "/demenagement-garches",
  "/demenagement-vaucresson",
  "/demenagement-herblay",
  "/demenagement-taverny",
  "/demenagement-ermont",
  "/demenagement-eaubonne",
  "/demenagement-beauchamp",
  "/demenagement-le-plessis-bouchard",
  "/demenagement-montigny-les-cormeilles",
  "/demenagement-cormeilles-en-parisis",
  "/demenagement-poissy",
  "/demenagement-boulogne-billancourt",
  "/demenagement-issy-les-moulineaux",
  "/demenagement-creteil",
  "/demenagement-vitry-sur-seine",
  "/demenagement-antony",
  "/demenagement-asnieres-sur-seine",
  "/demenagement-aubervilliers",
  "/demenagement-maisons-laffitte",
  "/demenagement-viroflay",
  "/demenagement-ville-davray",
  "/demenagement-le-chesnay-rocquencourt",
  "/demenagement-enghien-les-bains",
  "/demenagement-sceaux",
  "/demenagement-nogent-sur-marne",
  "/demenagement-le-perreux-sur-marne",
  "/demenagement-palaiseau",
  "/demenagement-cergy",
  "/demenagement-pontoise",
  "/demenagement-melun",
  "/demenagement-meaux",
];
